import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import { AppErrorBoundary } from "./components/feature/AppErrorBoundary";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AppErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </BrowserRouter>
      </AppErrorBoundary>
    </I18nextProvider>
  );
}

export default App;
